/**
 * @desc 获取角色对应权限信息（树）
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPermissionTreeResponse>>> {
  return defHttp.get({
    url: '/wap/rolePermission/listPermissions',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryPermissionTreeResponse>>> {
  return defHttp.get({
    url: '/mock/wap/rolePermission/listPermissions',
  });
}
